import React from 'react'
import { Modal } from 'react-bootstrap'

const ImagePopup = ({ showPopup, setShowPopup }) => {
    return (
        <Modal
            show={showPopup}
            onHide={() => setShowPopup(false)}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Preview</Modal.Title>
            </Modal.Header>
            <div className="p-3 d-flex ac-jc">
                <img
                    src={showPopup}
                    className="rounded "
                    style={{ width: "350px", height: "350px", objectFit: "contain" }}
                />
            </div>
            <div className="d-flex ac-jc mt-3 mb-3">
                <button onClick={() => setShowPopup(false)} className="no-btn">
                    Close
                </button>
            </div>
        </Modal>
    )
}

export default ImagePopup